/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Materiality
 */
export interface Materiality {
  /**
   *
   * @type {number}
   * @memberof Materiality
   */
  high: number;
  /**
   *
   * @type {number}
   * @memberof Materiality
   */
  medium: number;
  /**
   *
   * @type {number}
   * @memberof Materiality
   */
  low: number;
}

/**
 * Check if a given object implements the Materiality interface.
 */
export function instanceOfMateriality(value: object): value is Materiality {
  if (!('high' in value) || value['high'] === undefined) return false;
  if (!('medium' in value) || value['medium'] === undefined) return false;
  if (!('low' in value) || value['low'] === undefined) return false;
  return true;
}

export function MaterialityFromJSON(json: any): Materiality {
  return MaterialityFromJSONTyped(json, false);
}

export function MaterialityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Materiality {
  if (json == null) {
    return json;
  }
  return {
    high: json['high'],
    medium: json['medium'],
    low: json['low'],
  };
}

export function MaterialityToJSON(value?: Materiality | null): any {
  if (value == null) {
    return value;
  }
  return {
    high: value['high'],
    medium: value['medium'],
    low: value['low'],
  };
}
